import React, { useEffect, useState } from "react";
import styles from "../../../Common/DegreePage/styles.module.scss";
import LeftColoredTitle from "../../../components/Titles/LeftColoredTitle";
import CardInfo from "../../../components/Cards/CardInfo/CardInfo";
import MiniRightColoredTitle from "../../../components/MiniRightColoredTitle/MiniRightColoredTitle";

import {
  Curriculum,
  Objectifs,
  PerspecttivesProf,
  CerteficationsPage,
} from "../../../Common/DegreePage/DegreePage";

import {
  FaRegClock,
  FaGlobeAfrica,
  FaExclamationTriangle,
  FaRegCalendarAlt,
  FaDiaspora,
} from "react-icons/fa";

import { FadeUp } from "../../../components/Animations/Fade";
import { useLocation } from "react-router-dom";

import { deplomes } from "../data";

function AlterDegree() {
  const location = useLocation();
  const [degree, setDegree] = useState(null);
  const [selects, set_selects] = useState([
    "Présentation",
    "Objectifs",
    "Curriculum",
  ]);
  const [selected, set_selected] = useState("Présentation");

  useEffect(() => {
    let name = location.pathname.replace("/alternance/", "");

    let deg = deplomes.find((item) => {
      return item.title.toLowerCase().split(" ").join("-") === name;
    });

    setDegree(deg);
  }, [location]);

  if (!degree) return null;

  return (
    <div className={`${styles.main} ${styles.main_alt}`}>
      <LeftColoredTitle>{degree?.title}</LeftColoredTitle>

      <GlobalInfos degree={degree} />

      <div className={styles["choices"]}>
        {selects.map((item, key) => {
          return (
            <MiniRightColoredTitle
              key={key}
              active={item === selected}
              onClick={() => {
                set_selected(item);
              }}
            >
              {item}
            </MiniRightColoredTitle>
          );
        })}
      </div>

      {selected === "Présentation" && <PresentationSec degree={degree} />}
      {selected === "Curriculum" && <Curriculum degree={degree} />}
      {selected === "Certifications professionnelles" && (
        <CerteficationsPage degree={degree} />
      )}
      {selected === "Objectifs" && <Objectifs degree={degree} />}
      {selected === "Perspectives professionnelles" && (
        <PerspecttivesProf degree={degree} />
      )}
    </div>
  );
}

export const GlobalInfos = ({ degree }) => {
  return (
    <div className={styles["cards-infos"]}>
      <FadeUp className={styles["cards-cont"]}>
        <CardInfo title="Durée" Icon={FaRegClock}>
          <p>
            {degree.duration_type} :
            <strong style={{ fontWeight: "500", padding: "0px 0px 0px 5px" }}>
              {degree.duration}
            </strong>
          </p>
        </CardInfo>
      </FadeUp>

      <FadeUp className={styles["cards-cont"]}>
        <CardInfo title={"Condition d'admission"} Icon={FaExclamationTriangle}>
          <p>{degree.cond_adm}</p>
        </CardInfo>
      </FadeUp>

      <FadeUp className={styles["cards-cont"]}>
        <CardInfo title={"Début du programme"} Icon={FaRegCalendarAlt}>
          <p>Octobre</p>
        </CardInfo>
      </FadeUp>

      <FadeUp className={styles["cards-cont"]}>
        <CardInfo title={"Language"} Icon={FaGlobeAfrica}>
          <p>{degree.langue}</p>
        </CardInfo>
      </FadeUp>

      <FadeUp className={styles["cards-cont"]}>
        <CardInfo title={"Crédits"} Icon={FaDiaspora}>
          <p>120 ECTS</p>
        </CardInfo>
      </FadeUp>
    </div>
  );
};

export const PresentationSec = ({ degree }) => {
  return (
    <div>
      <div className={styles["pres-sec"]}>
        <p className={styles["descript"]}>{degree.long_desc}</p>
      </div>
    </div>
  );
};

export default AlterDegree;
